import SearchIcon from '@atlaskit/icon/core/search';
import React, { memo } from 'react';

export const CustomValueContainer = memo(function CustomValueContainer({
  children
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <SearchIcon label="" />
      {children}
    </>
  );
});
